import { apiUrls } from 'consts'
import { useEffect } from 'react'
import getAll from 'utils/getAll'

interface useInitProps {
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setServiceStatuses: Function
  setSections: Function
  setValue: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getAll(apiUrls.serviceStatuses).then((data) => {
      props.setServiceStatuses(data)
      getAll(apiUrls.reportConfig).then((reportConfigData) => {
        getAll(apiUrls.reportConfig + '/' + apiUrls.actionSectionNames).then((sectionsData) => {
          props.setSections(sectionsData)
        })
        if (Object.keys(reportConfigData).length) {
          props.reset(reportConfigData)
        }
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    })
  }, [])
}

export default useInit
